import { ProductsSearchBar } from "../../../products-search-bar";

const Middle = () => {
  return (
    <ProductsSearchBar />
  );
}

export default Middle;
